<div class="top-nav-options" [class.nav-disabled]="disabled()">
	@for (navItem of internalNavigationItems(); track navItem.linkText) {
		@let hasChildren = navItem.childNav && navItem.childNav.length > 0;

		@if (hasChildren) {
			<ng-container *ngTemplateOutlet="navigationParent; context: { navItem }"></ng-container>
		} @else {
			<ng-container *ngTemplateOutlet="navigationItem; context: { navItem, isChildNavItem: false }"></ng-container>
		}
	}
</div>

<div class="bottom-nav-options" [class.nav-disabled]="disabled()">
	@for (navItem of internalBottomNavigationItems(); track navItem.linkText) {
		<ng-container *ngTemplateOutlet="navigationItem; context: { navItem }"></ng-container>
	}

	<div class="nav-toggle" (click)="!disabled() && onToggleClick($event)" [class.nav-disabled]="disabled()" [attr.aria-label]="expanded() ? 'Collapse navigation' : 'Expand navigation'">
		@if (expanded()) {
			<md-icon>keyboard_double_arrow_left</md-icon>
			<span>Collapse</span>
		} @else {
			<md-icon>keyboard_double_arrow_right</md-icon>
		}
	</div>
</div>

<ng-template #navigationItem let-navItem="navItem" let-isChildNavItem="isChildNavItem">
	<div class="nav-item" [ngClass]="{ 'secondary-nav': isChildNavItem}">
		@if (navItem.routerLink) {
			<a [routerLink]="navItem.routerLink" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: !!navItem.exact }">
				<ng-container *ngTemplateOutlet="navigationLink; context: { navItem }"></ng-container>
			</a>
		}

		@if (navItem.href) {
			<a [href]="navItem.href" [attr.target]="navItem.target" [ngClass]="{ 'secondary-nav': isChildNavItem}">
				<ng-container *ngTemplateOutlet="navigationLink; context: { navItem }"></ng-container>
			</a>
		}

		@if (navItem.action) {
			<a (click)="navItem.action()">
				<ng-container *ngTemplateOutlet="navigationLink; context: { navItem }"></ng-container>
			</a>
		}
		
	</div>
</ng-template>

<ng-template #navigationParent let-navItem="navItem">
	<div class="nav-item">
		<a (click)="navItem.active = !navItem.active">
			<ng-container *ngTemplateOutlet="navigationLink; context: { navItem }"></ng-container>
			@if (navItem.active) {
				<md-icon class="chevron-spacing">keyboard_arrow_up</md-icon>
			}
			@else {
				<md-icon class="chevron-spacing">keyboard_arrow_down</md-icon>
			}
		</a>
	</div>
	@if (navItem.active) {
		@for (childNavItem of navItem.childNav; track childNavItem) {
			<ng-container *ngTemplateOutlet="navigationItem; context: { navItem: childNavItem, isChildNavItem: true }"></ng-container>
		}
	}
</ng-template>

<ng-template #navigationLink let-navItem="navItem">
	<md-icon [icon]="navItem.linkIcon"></md-icon>
	<span>
		{{ navItem.linkText }}
			@if (navItem.isBeta) {
			<lb-beta-tag></lb-beta-tag>
		}
		@if (navItem.badgeCount) {
			<md-tag class="nav-badge" type="error">{{ navItem.badgeCount }}</md-tag>
		}
	</span>
</ng-template>
